// Передача сохранённого графика в MS Project: общий блок отчётов (#122).
import { useState } from 'react';
import { call, p, authHdr, type Data } from './api';
import { confirmBox } from './dialog';
import type { ShellCtx } from './shell';

export function MspExport({ ctx }: { ctx: ShellCtx }) {
  const [detail, setDetail] = useState('tasks');
  const [scope, setScope] = useState('all');
  const [exporting, setExporting] = useState(false);
  const fail = (message: string) => ctx.onError?.(message);

  async function exportMsp() {
    setExporting(true);
    try {
      const params = '?format=mspxml&detail=' + detail + '&scope=' + scope;
      const r = await call<Data<'/api/projects/{pid}/export-info', 'get'>>('get',
        p('/api/projects/{pid}/export-info', { pid: ctx.pid }) + params);
      if (!r.ok) { fail(r.error.message); return; }
      if (r.data.preduprezhdeniya.length && !await confirmBox(r.data.preduprezhdeniya.join('\n\n'),
        { podpis: 'Передача в MS Project', ok: 'Скачать XML' })) return;
      // fetch с заголовком входа: токен не попадает в историю адресов и скачанный файл.
      const response = await fetch(p('/api/projects/{pid}/export', { pid: ctx.pid }) + params,
        { headers: authHdr() });
      if (!response.ok) {
        const body = await response.json();
        fail(body.error?.message || 'Не удалось скачать график'); return;
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob), a = document.createElement('a');
      a.href = url; a.download = 'plot_plan.xml'; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      ctx.onSaved?.('График передан в MS Project: задач ' + r.data.zadach + ', связей ' + r.data.svyazej + '.');
    } catch { fail('Не удалось получить файл. Проверьте соединение и повторите выгрузку.'); }
    finally { setExporting(false); }
  }

  return (
      <div className="bar msp-export">
        <label>MS Project{' '}
          <select aria-label="Детализация MS Project" title="Детализация выгружаемого графика" value={detail} onChange={e => setDetail(e.target.value)} disabled={exporting}>
            <option value="tasks">По этажам</option><option value="stroki">Строки ГПР по корпусам</option>
          </select>
        </label>
        <label>Состав{' '}
          <select aria-label="Состав выгрузки MS Project" title="Какой график передать" value={scope} onChange={e => setScope(e.target.value)} disabled={exporting}>
            <option value="all">Весь график</option><option value="tipovoe">Типовой</option><option value="ruchnoe">Ручной</option>
          </select>
        </label>
        <button className="sec" disabled={exporting} onClick={() => void exportMsp()}>{exporting ? 'Готовим XML…' : 'MS Project (XML)'}</button>
        <span className="muted" title="В файл входят текущие сохранённые даты, структура, связи и активный базовый план">Сохранённые сроки и активный базовый план</span>
      </div>
  );
}
